export default "__VITE_ASSET__BgN$pEDR__"